import Client from './client';

export default class OptinPromptCopies extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/internal/optin/prompt/copies`, {
      ...options,
       method: 'POST',
    });
  }

}
